import { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import PageTransition from '../components/PageTransition';
import EmergencyIconSvg from "../assets/icon_emergency.svg?react";
import { useTranslation } from 'react-i18next';

const PulseIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  60% {
    opacity: 1;
    transform: scale(1.10);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Wrapper = styled.main`
  background-color: ${p => p.theme.backgroundColor}; 
  color: #fff; 
  height: 100%; 
  width: 100%; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
`

const EmergencyIcon = styled(EmergencyIconSvg)`
  fill: ${p => p.theme.accentColor};
  animation: ${PulseIn} 0.5s ease-out;
  width: 150px;
  height: 150px;
`;

const EmergencyTitle = styled.h1`
  color: ${p => p.theme.textColor};
  animation: ${PulseIn} 0.5s ease-out;
  font-size: 1.8em;
  text-transform: uppercase;
  margin: 10px 0 0;
`;

const EmergencyText = styled.span`
  color: ${p => p.theme.textColor};
  animation: ${PulseIn} 0.5s ease-out;
  font-size: 1.2em;
`;

/**
 * Render a the fire alert view
 * @returns {JSX.Element} Component template
 */
const AlertView: FC = () => {
  const { t } = useTranslation();

  return (
    <PageTransition>
      <Wrapper>
        <EmergencyIcon/>
        <EmergencyTitle>{t("firealert.title")}</EmergencyTitle>
        <EmergencyText>{t("firealert.text")}</EmergencyText>
      </Wrapper>
    </PageTransition>
  );
}

export default AlertView;